/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_2Inputs */

const en_pc_tut_search_2 = /** @type {(inputs: Pc_Tut_Search_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a word or phrase. Every match is highlighted immediately.`)
};

const zh_pc_tut_search_2 = /** @type {(inputs: Pc_Tut_Search_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入词语，所有匹配项立即高亮。`)
};

/**
* | output |
* | --- |
* | "Type a word or phrase. Every match is highlighted immediately." |
*
* @param {Pc_Tut_Search_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_2 = /** @type {((inputs?: Pc_Tut_Search_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_2(inputs)
	return zh_pc_tut_search_2(inputs)
});
export { pc_tut_search_2 as "pc.tut.search.2" }